
import { Button } from "../../atoms/RTCC/button";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import close from "../../../resources/RTCC/icons/ico_X.svg";
import detail from "../../../resources/RTCC/icons/ico_modal.svg";
import reserve from "../../../resources/RTCC/icons/ico_reserve.svg";

import { Detail } from "../../molecules/RTCC/detail";

export const InstitutionDetailModalContainer = (props) => {
    const { onClickPopup, popupData, onClickService, onClickService2, idName } = props;
    const history = useHistory();

    const [displaySwitch, setDisplaySwitch] = useState(false);
    // レスポンシブ対応
    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const onClickSetDisplaySwitch = () => {
        setDisplaySwitch(!displaySwitch);
    };

    const onClickCatalogHome = () => {
        history.push("/rtcc/catalog/home");
    };

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    // 予約確認ボタン押下処理
    const onClickGolfReserveChk = () => {
        history.push("/reserve/golf/reservationCheck");
    };

    const onClickServiceBtn = () => {
        setDisplaySwitch(!displaySwitch);
        onClickService();
    }

    return (
        <div>
            <div>
                <Button buttonText="詳細" className="DetailButtonOpen" buttonClassName="DetailButtonOpenText" btnImage={detail} onClick={onClickSetDisplaySwitch} />
                {idName === 1 ?
                    <Button buttonText="予約確認" className="golf_DetailButtonOpenReserveChk" buttonClassName="golf_DetailButtonOpenText" btnImage={reserve} onClick={onClickGolfReserveChk} />
                    :
                    null
                }
            </div>
            <div className={displaySwitch ? "popupIsShow" : "popup"}>
                <div className={isMobilePhone ? "popupInnerMobile" : "popupInner"}>
                    <Button buttonText="" className="closeBtn svg" btnImage={close} onClick={onClickSetDisplaySwitch} />
                    <Detail plan={popupData} onClickPopup={onClickPopup} />
                    {idName == "2" ?
                        <Button buttonText="RTCCカタログサイトへ" className="CatalogHomeButtonModal" buttonClassName="ReservationButtonText" btnImage={reserve} onClick={onClickCatalogHome} />
                        :
                        //以下一人予約ボタン表示時にコメントアウト外す
                        idName === 1 ?
                        <>
                            <Button buttonText="組予約する" className="ReservationButtonModalGolfGroup" buttonClassName="ReservationButtonText" btnImage={reserve} onClick={onClickService} />
                            <Button buttonText="１人予約する" className="ReservationButtonModal" buttonClassName="ReservationButtonText" btnImage={reserve} onClick={onClickService2} />
                        </>
                        :
                        //ここまで
                        <Button buttonText="予約する" className="ReservationButtonModal" buttonClassName="ReservationButtonText" btnImage={reserve} onClick={onClickServiceBtn} />
                    }
                </div>
                <div className="blackBackground"></div>
            </div>
        </div>
    );
}

